import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { Content, Step } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { CONTENT, CONFIG_WITH_FAMILY_AND_ELIGIBILITY } = USA
const { WELCOME, REGISTRATION, FAMILY, SUMMARY, ELIGIBILITY } = CONTENT

const partnerName = 'Home State Health'

const welcomeContent: Step = {
  ...WELCOME.enUS,
  copy: [
    'Get health care any time from your phone. We’ve partnered with Home State Health to provide you and your family 24/7 total care at no cost, right from your phone.',
  ],
}

const content: Content = {
  'en-US': {
    steps: [
      welcomeContent,
      REGISTRATION.enUS,
      FAMILY.enUS,
      ELIGIBILITY.enUS,
      SUMMARY.enUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
}

const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
    id: 'hsh-medicaid-vbc',
    productConfigAppName: 'hsh-medicaid-vbc',
    name: partnerName,
    codes: {
      membership: 'HSHVBC',
    },
    partnerUrlSlug: 'hsh-vbc',
  },
  content,
}

const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
}

export default [baseConfig, baseConfigWithDnaV2Design]
